module.exports = __webpack_public_path__ + "img/button-icon-license.fab47c03.svg";